import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Chip,
  LinearProgress,
  useTheme,
  Paper,
  Tooltip,
} from "@mui/material";
import {
  Search,
  ChatBubble,
  ErrorOutline,
  Warning,
  AttachMoney,
} from "@mui/icons-material";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import InfoIcon from "@mui/icons-material/Info";
import CustomerMetrics from "./CustomerMetrics";
import { palette, theme as colorTheme } from "../../../../Convoze.theme";



// const colors = ["#fee2e2", "#dcfce7", "#dbeafe", "#fef9c3"];
// const textColors = ["#9c2e42", "#2e7044", "#5d4eae", "#8b5f3e"];


const positive = colorTheme('palette', 'positive').value;
const positiveBg = colorTheme('palette', 'positiveBg').value;
const negative = colorTheme('palette', 'negative').value;
const negativeBg = colorTheme('palette', 'negativeBg').value;
const neutral= colorTheme('palette', 'neutral').value;
const neutralBg = colorTheme('palette', 'neutralBg').value;
const primary= colorTheme('palette', 'primary').value;
const primaryBg = colorTheme('palette', 'primaryBg').value;


  // const colors = [ colorTheme('palette', 'negativeBg').value, colorTheme('palette', 'positiveBg').value, colorTheme('palette', 'primaryBg').value,  colorTheme('palette', 'neutralBg').value]
  const colors = [negativeBg, positiveBg, primaryBg, neutralBg]
  const textColors = ["#9c2e42", "#2e7044", "#5d4eae", "#8b5f3e"];



const CustomerAnalytics = ({ customerAnalytics }) => {

  const theme = useTheme();

  const scoreFactors = [
    {
      factor: "Negative phrases frequency",
      impact:
        customerAnalytics?.CustomerIntentAndPainPointDetection
          ?.CustomerExperienceScore?.ScoreBreakdown?.NegativePhrasesFrequency,
      // color: "#f44336",
      color:colorTheme('palette', 'negative').value

    },
    {
      factor: "Escalation attempt",
      impact:
        customerAnalytics?.CustomerIntentAndPainPointDetection
          ?.CustomerExperienceScore?.ScoreBreakdown?.EscalationAttempt,
      // color: "#f44336",
      color:colorTheme('palette', 'negative').value
    },
    {
      factor: "Repetition of issue",
      impact:
        customerAnalytics?.CustomerIntentAndPainPointDetection
          ?.CustomerExperienceScore?.ScoreBreakdown?.RepetitionOfIssue,
      // color: "#f44336",
      color:colorTheme('palette', 'negative').value
    },
    {
      factor: "Time to resolution",
      impact:
        customerAnalytics?.CustomerIntentAndPainPointDetection
          ?.CustomerExperienceScore?.ScoreBreakdown?.TimeToResolution,
      // color: "#4caf50",
      color:colorTheme('palette', 'positive').value
    },
  ];

  // Comparison scale data
  const comparisonScale = [
    { label: "Poor", color: colorTheme('palette', 'negativeBg').value, range: [0, 20] },
    { label: "Below Avg", color: colorTheme('palette', 'negativeBg').value, range: [21, 40] },
    { label: "Average", color: colorTheme('palette', 'primaryBg').value, range: [41, 60] },
    { label: "Good", color: colorTheme('palette', 'neutralBg').value, range: [61, 80] },
    { label: "Excellent", color: colorTheme('palette', 'positiveBg').value, range: [81, 100] },
  ];

  // Current score and average
  const currentScore =
    customerAnalytics?.CustomerIntentAndPainPointDetection
      ?.CustomerExperienceScore?.ComparisonToAverage?.ThisCall;
  const averageScore =
    customerAnalytics?.CustomerIntentAndPainPointDetection
      ?.CustomerExperienceScore?.ComparisonToAverage?.Average;

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={3}>
        {/* Customer Intent & Pain Point Detection */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            // justifyContent: "space-between",
            gap: 3,
            // backgroundColor:'red'
          }}
        >
          <Paper elevation={1} sx={{ flex: 1, p: 1, borderRadius: 2 }}>
            <CardContent
              sx={{ display: "flex", flexDirection: "column", gap: 4 }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Typography variant="body1" fontWeight={500}>
                  🔍 Customer Intent & Pain Point Detection
                </Typography>
                <Tooltip
                  title="Gives the intent behind the call and also the customer's paint point detected in the conversation."
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <InfoIcon
                    sx={{
                      fontSize: 18,
                      color: "grey",
                    }}
                  />
                </Tooltip>
              </Box>

              {/* Detected Intent */}
              <Box>
                <Typography variant="body2" gutterBottom>
                  Detected Intent
                </Typography>

                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1 }}>
                  {customerAnalytics?.CustomerIntentAndPainPointDetection
                    ?.MainIntents?.length > 0 ? (
                    customerAnalytics?.CustomerIntentAndPainPointDetection?.MainIntents?.map(
                      (intent, index) => (
                        <Chip
                          key={index}
                          label={`${intent}`}
                          sx={{
                            backgroundColor: colors[index % colors.length],
                            // color: textColors[index % textColors.length],
                            color:"black",
                            fontWeight: 550,
                          }}
                        />
                      )
                    )
                  ) : (
                    <Chip
                      label="No data available."
                      size="small"
                      sx={{
                        mt: 2,
                        backgroundColor: "#E4E5E7",
                        color: "#5F6062",
                        fontWeight: 500,
                        px: 1.5,
                        py: 0.5,
                        borderRadius: "4px",
                      }}
                    />
                  )}
                </Box>
              </Box>

              {/* Intent Transitions */}
              <Box
                gap={4}
                sx={
                  {
                    // mb: 4
                  }
                }
              >
                <Typography variant="body2" gutterBottom>
                  Intent Transitions Across Call
                </Typography>


             
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                    borderRadius: 1,
                    overflow: "hidden",
                    mt: 1,
                  }}
                >
                  {customerAnalytics?.CustomerIntentAndPainPointDetection
                    ?.IntentTransitions?.length > 0 ? (
                    customerAnalytics?.CustomerIntentAndPainPointDetection?.IntentTransitions?.map(
                      (transition, index) => (
                        <Box
                          key={index}
                          sx={{
                            flex: 1,
                            // bgcolor: "#fff8e1",
                            backgroundColor: index % 2 === 0 ? negativeBg : positiveBg,
                            p: 1.5,
                            textAlign: "center",
                            color:"black"
                          }}
                        >
                          <Typography variant="body2" fontWeight="500">
                            {transition?.Intent} &nbsp;({transition?.StartTime}{" "}
                            - {transition?.EndTime})
                          </Typography>
                        </Box>
                      )
                    )
                  ) : (
                    <Chip
                      label="No data available."
                      size="small"
                      sx={{
                        mt: 2,
                        backgroundColor: "#E4E5E7",
                        color: "#5F6062",
                        fontWeight: 500,
                        px: 1.5,
                        py: 0.5,
                        borderRadius: "4px",
                      }}
                    />
                  )}
                </Box>

                


              </Box>






              {/* AI-Highlighted Pain Points */}
              <Box>
                <Typography variant="body2" gutterBottom>
                  AI-Highlighted Pain Points
                </Typography>

                {customerAnalytics?.CustomerIntentAndPainPointDetection
                  ?.AIHighlightedPainPoints?.length > 0 ? (
                  customerAnalytics?.CustomerIntentAndPainPointDetection?.AIHighlightedPainPoints?.map(
                    (point, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          mb: 2,
                          p: 1,
                          mt: 1,
                          borderRadius: 1,
                          backgroundColor: colors[index % colors.length],
                          // color: textColors[index % textColors.length],
                          color:"black",
                          // border: `1px ${colors[index % colors.length]}`,
                          // border :"1px solid gray"
                        }}
                      >
                        <Box>
                          <Typography variant="body2" fontWeight="500" p={1}>
                            {point}
                          </Typography>
                        </Box>
                      </Box>
                    )
                  )
                ) : (
                  <Chip
                    label="No data available."
                    size="small"
                    sx={{
                      mt: 2,
                      backgroundColor: "#E4E5E7",
                      color: "#5F6062",
                      fontWeight: 500,
                      px: 1.5,
                      py: 0.5,
                      borderRadius: "4px",
                    }}
                  />
                )}
              </Box>
            </CardContent>
          </Paper>
          {/* <Paper
            elevation={1}
            sx={{ flex: 1, p: 2.2, borderRadius: 2, py: 2.5 }}
          >
            <Typography
              variant="body2"
              gutterBottom
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              Frequently Used Words
              <Tooltip
                title="Gives the most frequently used words during the conversation from the customers side."
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <InfoIcon
                  sx={{
                    fontSize: 18,
                    color: "grey",
                  }}
                />
              </Tooltip>
            </Typography>
            <Box
              sx={{
                mb: 2,
                mt: 2,
                borderRadius: 3,
                bgcolor: "#f9fafb",
                border: "1px solid #e5e7eb",
                p: 2,
                py: 3,
              }}
            >
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {customerAnalytics?.KeywordsAndThemes?.FrequentKeywords
                  ?.length > 0 ? (
                  customerAnalytics?.KeywordsAndThemes?.FrequentKeywords?.map(
                    (word, index) => (
                      <Chip
                        key={index}
                        size="small"
                        label={`${word}`}
                        sx={{
                          backgroundColor: colors[index % colors.length],
                          color: textColors[index % textColors.length],
                          fontWeight: 400,
                          fontSize: "0.875rem",
                        }}
                      />
                    )
                  )
                ) : (
                  <Chip
                    label="No data available."
                    size="small"
                    sx={{
                      mt: 2,
                      backgroundColor: "#E4E5E7",
                      color: "#5F6062",
                      fontWeight: 500,
                      px: 1.5,
                      py: 0.5,
                      borderRadius: "4px",
                    }}
                  />
                )}
              </Box>
            </Box>
          </Paper> */}
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            // justifyContent: "space-between",
            gap: 3,
            // backgroundColor:'red'
          }}
        >
          <CustomerMetrics customerAnalytics={customerAnalytics} />
        </Grid>

        {/* Customer Experience Score */}
        {/* <Grid
          item
          xs={12}
          md={6}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Paper elevation={1} sx={{ flex: 1, p: 1, borderRadius: 2 }}>
            <CardContent>
              <Box
                sx={{ display: "flex", alignItems: "center", mb: 3, gap: 1 }}
              >
                <Typography variant="body1" component="div">
                  🧠 Customer Experience Score
                </Typography>
                <Tooltip
                  title="Gives the average score of the Customer Experience"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <InfoIcon
                    sx={{
                      fontSize: 18,
                      color: "grey",
                    }}
                  />
                </Tooltip>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  mb: 3,
                }}
              >
                <Box sx={{ width: 180, height: 180 }}>
                  <CircularProgressbar
                    value={
                      customerAnalytics?.CustomerIntentAndPainPointDetection
                        ?.CustomerExperienceScore?.Score
                    }
                    maxValue={100}
                    text={`${
                      customerAnalytics?.CustomerIntentAndPainPointDetection
                        ?.CustomerExperienceScore?.Score == undefined
                        ? 0
                        : customerAnalytics?.CustomerIntentAndPainPointDetection
                            ?.CustomerExperienceScore?.Score
                    }`}
                    styles={buildStyles({
                      textSize: "24px",
                      pathColor: `${theme.palette.warning.main}`,
                      textColor: theme.palette.text.primary,
                      trailColor: "#f5f5f5",
                      pathTransitionDuration: 0.5,
                    })}
                  />
                </Box>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mt: 1 }}
                >
                  out of 100
                </Typography>
                <Chip
                  label={
                    customerAnalytics?.CustomerIntentAndPainPointDetection
                      ?.CustomerExperienceScore?.Rating
                  }
                  size="small"
                  sx={{
                    mt: 2,
                    bgcolor: "#fff8e1",
                    color: "#f57c00",
                    fontWeight: 500,
                  }}
                />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mt: 1 }}
                >
                  {
                    customerAnalytics?.CustomerIntentAndPainPointDetection
                      ?.CustomerExperienceScore?.DeltaFromAverage
                  }{" "}
                  from similar calls
                </Typography>
              </Box>

              <Box sx={{ mb: 4 }}>
                <Typography variant="body2" gutterBottom>
                  Score Derivation
                </Typography>
                {scoreFactors?.map((factor, index) => (
                  <Box
                    key={index}
                    sx={{ display: "flex", alignItems: "center", mb: 1.5 }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "60%",
                      }}
                    >
                      {factor?.impact < 0 ? (
                        <ErrorOutline
                          fontSize="small"
                          sx={{ color: "#f44336", mr: 1 }}
                        />
                      ) : (
                        <Box
                          sx={{
                            width: 18,
                            height: 18,
                            borderRadius: "50%",
                            bgcolor: "#e8f5e9",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mr: 1,
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{ color: "#4caf50", fontWeight: "bold" }}
                          >
                            ✓
                          </Typography>
                        </Box>
                      )}
                      <Typography variant="body2">{factor?.factor}</Typography>
                    </Box>
                    <Box
                      sx={{
                        width: "40%",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <LinearProgress
                        variant="determinate"
                        value={
                          factor.impact > 0
                            ? (Math.abs(factor.impact) / 5) * 100
                            : 0
                        }
                        sx={{
                          height: 8,
                          borderRadius: 4,
                          flexGrow: 1,
                          mr: 1,
                          bgcolor: "#e0e0e0",
                          "& .MuiLinearProgress-bar": {
                            bgcolor:
                              factor.impact < 2.5 ? "#f44336" : "#4caf50",
                          },
                        }}
                      />
                      <Typography
                        variant="body2"
                        fontWeight="500"
                        sx={{
                          color: factor.impact < 2.5 ? "#f44336" : "#4caf50",
                          width: 50,
                        }}
                      >
                        {factor?.impact || 0} / 5
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>

              <Box>
                <Typography
                  variant="body2"
                  gutterBottom
                  sx={{ display: "flex", alignItems: "center", gap: 1 }}
                >
                  Comparison to Average
                  <Tooltip
                    title="Comparison of the customer's score on the call with their average score of all calls"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <InfoIcon
                      sx={{
                        fontSize: 18,
                        color: "grey",
                      }}
                    />
                  </Tooltip>
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 1,
                  }}
                >
                  <Typography variant="body2" color="#f44336" fontWeight="500">
                    This Call: {currentScore || "NA"}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Avg: {averageScore || "NA"}
                  </Typography>
                </Box>

                <Box sx={{ position: "relative", mb: 1 }}>
                  <Box
                    sx={{
                      display: "flex",
                      width: "100%",
                      borderRadius: 1,
                      overflow: "hidden",
                    }}
                  >
                    {comparisonScale?.map((segment, index) => (
                      <Box
                        key={index}
                        sx={{
                          flex: segment.range[1] - segment.range[0],
                          bgcolor: segment.color,
                          p: 1,
                          textAlign: "center",
                        }}
                      >
                        <Typography variant="caption">
                          {segment?.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>

                  <Box
                    sx={{
                      position: "absolute",
                      left: `${currentScore}%`,
                      top: 0,
                      bottom: 0,
                      width: 2,
                      bgcolor: "#fff",
                      transform: "translateX(-50%)",
                      zIndex: 1,
                      borderColor: "red",
                      borderStyle: "dashed",
                    }}
                  />

                  <Box
                    sx={{
                      position: "absolute",
                      left: `${averageScore}%`,
                      top: 0,
                      bottom: 0,
                      width: 2,
                      bgcolor: "#9e9e9e",
                      transform: "translateX(-50%)",
                      zIndex: 1,
                      borderStyle: "dashed",
                    }}
                  />
                </Box>
              </Box>
            </CardContent>
          </Paper>
        </Grid> */}
      </Grid>
    </Box>
  );
};

export default CustomerAnalytics;
